var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"tag":_vm.tag,"name":"dv-stagger","css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }